<template>
  <div class="container">
    <div class="basicsBox" v-loading='loading'>
      <div class="basics" :class="(examineInfo.order_origin.project_name || examineInfo.order_origin.project_name == '') ? 'change':''">
        <label>项目名称：</label>
        <el-tooltip effect="dark" :content="examineInfo.order.project_name" :disabled="examineInfo&&examineInfo.order&&examineInfo.order.project_name&&examineInfo.order.project_name.length>8?false:true" placement="top-start">
          <span class="ellipsis">{{examineInfo.order.project_name}}</span>
        </el-tooltip>
        <em v-if="examineInfo.order_origin.project_name || examineInfo.order_origin.project_name == ''">原值：{{examineInfo.order_origin.project_name}}</em>
      </div>
      <div class="basics" :class="(examineInfo.order_origin.advertiser_account || examineInfo.order_origin.advertiser_account == '') ? 'change':''">
        <label>所属账户：</label>
        <span>{{examineInfo.order.advertiser_account}}</span>
        <em v-if="examineInfo.order_origin.advertiser_account || examineInfo.order_origin.advertiser_account == ''">原值：{{examineInfo.order_origin.advertiser_account}}</em>
      </div>
      <div class="basics" :class="(examineInfo.order_origin.advertiser_id || examineInfo.order_origin.advertiser_id == '') ? 'change':''">
        <label>所属账户ID：</label>
        <span>{{examineInfo.order.advertiser_id}}</span>
        <em v-if="examineInfo.order_origin.advertiser_id || examineInfo.order_origin.advertiser_id == ''">原值：{{examineInfo.order_origin.advertiser_id}}</em>
      </div>
      <div class="basics" :class="(examineInfo.order_origin.company || examineInfo.order_origin.company == '') ? 'change':''">
        <label>签约公司：</label>
        <el-tooltip effect="dark" :content="examineInfo.order.company" :disabled="examineInfo&&examineInfo.order&&examineInfo.order.company&&examineInfo.order.company.length>8?false:true" placement="top-start">
          <span class="ellipsis">{{examineInfo.order.company}}</span>
        </el-tooltip>
        <em v-if="examineInfo.order_origin.company || examineInfo.order_origin.company == ''">原值：{{examineInfo.order_origin.company}}</em>
      </div>
      <div class="basics" :class="(examineInfo.order_origin.month || examineInfo.order_origin.month == '') ? 'change':''">
        <label>所属月份：</label>
        <span>{{examineInfo.order.month}}</span>
        <em v-if="examineInfo.order_origin.month || examineInfo.order_origin.month == ''">原值：{{examineInfo.order_origin.month}}</em>
      </div>
      <div class="basics" :class="(examineInfo.order_origin.salesman || examineInfo.order_origin.salesman == '') ? 'change':''">
        <label>销售人员：</label>
        <span>{{examineInfo.order.salesman}}</span>
        <em v-if="examineInfo.order_origin.salesman || examineInfo.order_origin.salesman == ''">原值：{{examineInfo.order_origin.salesman}}</em>
      </div>
      <div class="basics" :class="(examineInfo.order_origin.handler || examineInfo.order_origin.handler == '') ? 'change':''">
        <label>经手人员：</label>
        <span>{{examineInfo.order.handler}}</span>
        <em v-if="examineInfo.order_origin.handler || examineInfo.order_origin.handler == ''">原值：{{examineInfo.order_origin.handler}}</em>
      </div>
      <div class="basics" :class="(examineInfo.order_origin.customer_name || examineInfo.order_origin.customer_name == '') ? 'change':''">
        <label>客户全称：</label>
        <span>{{examineInfo.order.customer_name}}</span>
        <em v-if="examineInfo.order_origin.customer_name || examineInfo.order_origin.customer_name == ''">原值：{{examineInfo.order_origin.customer_name}}</em>
      </div>
      <div class="basics" :class="(examineInfo.order_origin.launch_platform || examineInfo.order_origin.launch_platform == '') ? 'change':''">
        <label>投放平台：</label>
        <span>{{examineInfo.order.launch_platform}}</span>
        <em v-if="examineInfo.order_origin.launch_platform || examineInfo.order_origin.launch_platform == ''">原值：{{examineInfo.order_origin.launch_platform}}</em>
      </div>
      <div class="basics" :class="(examineInfo.order_origin.media_name || examineInfo.order_origin.media_name == '') ? 'change':''">
        <label>媒体名称：</label>
        <span>{{examineInfo.order.media_name}}</span>
        <em v-if="examineInfo.order_origin.media_name || examineInfo.order_origin.media_name == ''">原值：{{examineInfo.order_origin.media_name}}</em>
      </div>
    </div>
    <!-- 销售填写 -->
    <div class="writeBox">
      <p class="title">销售填写</p>
      <div class="writeItem" :class="(examineInfo.order_origin.internet_celebrity_name || examineInfo.order_origin.internet_celebrity_name == '') ? 'change':''">
        <label>网红名称：</label>
        <span>{{examineInfo.order.internet_celebrity_name}}</span>
        <em v-if="examineInfo.order_origin.internet_celebrity_name || examineInfo.order_origin.internet_celebrity_name == ''">原值：{{examineInfo.order_origin.internet_celebrity_name}}</em>
      </div>

      <div class="writeItem" :class="(examineInfo.order_origin.launch_start_date || examineInfo.order_origin.launch_start_date == '') ? 'change':''">
        <label>投放起始日期：</label>
        <span>{{examineInfo.order.launch_start_date}}</span>
        <em v-if="examineInfo.order_origin.launch_start_date || examineInfo.order_origin.launch_start_date == ''">原值：{{examineInfo.order_origin.launch_start_date}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.amount || examineInfo.order_origin.amount == '') ? 'change':''">
        <label>订单金额：</label>
        <span>{{examineInfo.order.amount}}</span>
        <em v-if="examineInfo.order_origin.amount || examineInfo.order_origin.amount == ''">原值：{{examineInfo.order_origin.amount}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.internet_celebrity_id || examineInfo.order_origin.internet_celebrity_id == '') ? 'change':''">
        <label>ID：</label>
        <span>{{examineInfo.order.internet_celebrity_id}}</span>
        <em v-if="examineInfo.order_origin.internet_celebrity_id || examineInfo.order_origin.internet_celebrity_id == ''">原值：{{examineInfo.order_origin.internet_celebrity_id}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.launch_end_date || examineInfo.order_origin.launch_end_date == '') ? 'change':''">
        <label>投放截止日期：</label>
        <span>{{examineInfo.order.launch_end_date}}</span>
        <em v-if="examineInfo.order_origin.launch_end_date || examineInfo.order_origin.launch_end_date == ''">原值：{{examineInfo.order_origin.launch_end_date}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.final_amount || examineInfo.order_origin.final_amount == '') ? 'change':''">
        <label>订单最终收入金额：</label>
        <span>{{examineInfo.order.final_amount}}</span>
        <em v-if="examineInfo.order_origin.final_amount || examineInfo.order_origin.final_amount == ''">原值：{{examineInfo.order_origin.final_amount}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.rebate_spending_ratio || examineInfo.order_origin.rebate_spending_ratio == '') ? 'change':''">
        <label>返点支出比例：</label>
        <span>{{examineInfo.order.rebate_spending_ratio}}</span>
        <em v-if="examineInfo.order_origin.rebate_spending_ratio || examineInfo.order_origin.rebate_spending_ratio == ''">原值：{{examineInfo.order_origin.rebate_spending_ratio}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.uninvoiced_amount || examineInfo.order_origin.uninvoiced_amount == '') ? 'change':''">
        <label>未开票金额：</label>
        <span>{{examineInfo.order.uninvoiced_amount}}</span>
        <em v-if="examineInfo.order_origin.uninvoiced_amount || examineInfo.order_origin.uninvoiced_amount == ''">原值：{{examineInfo.order_origin.uninvoiced_amount}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.billing_date || examineInfo.order_origin.billing_date == '') ? 'change':''">
        <label>开票日期：</label>
        <span>{{examineInfo.order.billing_date}}</span>
        <em v-if="examineInfo.order_origin.billing_date || examineInfo.order_origin.billing_date == ''">原值：{{examineInfo.order_origin.billing_date}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.rebate_expense_receiving_unit || examineInfo.order_origin.rebate_expense_receiving_unit == '') ? 'change':''">
        <label>返点支出收款单位：</label>
        <span>{{examineInfo.order.rebate_expense_receiving_unit}}</span>
        <em v-if="examineInfo.order_origin.rebate_expense_receiving_unit || examineInfo.order_origin.rebate_expense_receiving_unit == ''">原值：{{examineInfo.order_origin.rebate_expense_receiving_unit}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.invoice_amount || examineInfo.order_origin.invoice_amount == '') ? 'change':''">
        <label style="font-size:12px">开票金额：</label>
        <span>{{examineInfo.order.invoice_amount}}</span>
        <em v-if="examineInfo.order_origin.invoice_amount || examineInfo.order_origin.invoice_amount == ''">原值：{{examineInfo.order_origin.invoice_amount}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.payment_date || examineInfo.order_origin.payment_date == '') ? 'change':''">
        <label>回款日期：</label>
        <span>{{examineInfo.order.payment_date}}</span>
        <em v-if="examineInfo.order_origin.payment_date || examineInfo.order_origin.payment_date == ''">原值：{{examineInfo.order_origin.payment_date}}</em>
      </div>
    </div>
    <div class="writeBox">
      <div class="writeItem" :class="(examineInfo.order_origin.if_public || examineInfo.order_origin.if_public == '') ? 'change':''">
        <label>是否对公：</label>
        <span>{{examineInfo.order.if_public==1?'是':'否'}}</span>
        <em v-if="examineInfo.order_origin.if_public || examineInfo.order_origin.if_public == ''">原值：{{examineInfo.order_origin.if_public==1?'是':'否'}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.cost || examineInfo.order_origin.cost == '') ? 'change':''">
        <label>订单成本消耗：</label>
        <span>{{examineInfo.order.cost}}</span>
        <em v-if="examineInfo.order_origin.cost || examineInfo.order_origin.cost == ''">原值：{{examineInfo.order_origin.cost}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.traffic_boost_refund || examineInfo.order_origin.traffic_boost_refund == '') ? 'change':''">
        <label>流量助推(使用返货)：</label>
        <span>{{examineInfo.order.traffic_boost_refund}}</span>
        <em v-if="examineInfo.order_origin.traffic_boost_refund || examineInfo.order_origin.traffic_boost_refund == ''">原值：{{examineInfo.order_origin.traffic_boost_refund}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.traffic_boost_money || examineInfo.order_origin.traffic_boost_money == '') ? 'change':''">
        <label>流量助推(使用现金)</label>
        <span>{{examineInfo.order.traffic_boost_money}}</span>
        <em v-if="examineInfo.order_origin.traffic_boost_money || examineInfo.order_origin.traffic_boost_money == ''">原值：{{examineInfo.order_origin.traffic_boost_money}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.traffic_boost_sum || examineInfo.order_origin.traffic_boost_sum == '') ? 'change':''">
        <label>流量助推合计：</label>
        <span>{{examineInfo.order.traffic_boost_sum}}</span>
        <em v-if="examineInfo.order_origin.traffic_boost_sum || examineInfo.order_origin.traffic_boost_sum == ''">原值：{{examineInfo.order_origin.traffic_boost_sum}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.top_fee || examineInfo.order_origin.top_fee == '') ? 'change':''">
        <label>置顶费：</label>
        <span>{{examineInfo.order.top_fee}}</span>
        <em v-if="examineInfo.order_origin.top_fee || examineInfo.order_origin.top_fee == ''">原值：{{examineInfo.order_origin.top_fee}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.saler_note || examineInfo.order_origin.saler_note == '') ? 'change':''">
        <label>利润异常原因：</label>
        <span>{{examineInfo.order.saler_note}}</span>
        <em v-if="examineInfo.order_origin.saler_note || examineInfo.order_origin.saler_note == ''">原值：{{examineInfo.order_origin.saler_note}}</em>
      </div>
    </div>
    <!-- 媒介填写 -->
    <div class="writeBox">
      <p class="title">媒介填写</p>
      <!-- <div class="writeItem" :class="(examineInfo.order_origin.project_name_second || examineInfo.order_origin.project_name_second == '') ? 'change':''">
                <label>项目名称2：</label>
                <span>{{examineInfo.order.project_name_second}}</span>
                <em v-if="examineInfo.order_origin.project_name_second || examineInfo.order_origin.project_name_second == ''">原值：{{examineInfo.order_origin.project_name_second}}</em>
            </div> -->
      <div class="writeItem" :class="(examineInfo.order_origin.offline_subsidy_amount || examineInfo.order_origin.offline_subsidy_amount == '') ? 'change':''">
        <label>线下补款金额：</label>
        <span>{{examineInfo.order.offline_subsidy_amount}}</span>
        <em v-if="examineInfo.order_origin.offline_subsidy_amount || examineInfo.order_origin.offline_subsidy_amount == ''">原值：{{examineInfo.order_origin.offline_subsidy_amount}}</em>
      </div>

      <div class="writeItem" :class="(examineInfo.order_origin.offline_subsidy_company || examineInfo.order_origin.offline_subsidy_company == '') ? 'change':''">
        <label>线下付款公司：</label>
        <span>{{examineInfo.order.offline_subsidy_company}}</span>
        <em v-if="examineInfo.order_origin.offline_subsidy_company || examineInfo.order_origin.offline_subsidy_company == ''">原值：{{examineInfo.order_origin.offline_subsidy_company}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.payes || examineInfo.order_origin.payes == '') ? 'change':''">
        <label>收款人：</label>
        <span>{{examineInfo.order.payes}}</span>
        <em v-if="examineInfo.order_origin.payes || examineInfo.order_origin.payes == ''">原值：{{examineInfo.order_origin.payes}}</em>
      </div>
      <!-- <div class="writeItem" :class="(examineInfo.order_origin.payment_time || examineInfo.order_origin.payment_time == '') ? 'change':''">
                <label>收款日期：</label>
                <span>{{examineInfo.order.payment_time}}</span>
                <em v-if="examineInfo.order_origin.payment_time || examineInfo.order_origin.payment_time == ''">原值：{{examineInfo.order_origin.payment_time}}</em>
            </div> -->
      <div class="writeItem" :class="(examineInfo.order_origin.note || examineInfo.order_origin.note == '') ? 'change':''">
        <label>备注：</label>
        <span>{{examineInfo.order.note}}</span>
        <em v-if="examineInfo.order_origin.note || examineInfo.order_origin.note == ''">原值：{{examineInfo.order_origin.note}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.mcn_name || examineInfo.order_origin.mcn_name == '') ? 'change':''">
        <label>mcn返点机构全称：</label>
        <span>{{examineInfo.order.mcn_name}}</span>
        <em v-if="examineInfo.order_origin.mcn_name || examineInfo.order_origin.mcn_name == ''">原值：{{examineInfo.order_origin.mcn_name}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.mcn_rebate || examineInfo.order_origin.mcn_rebate == '') ? 'change':''">
        <label>mcn返点收入金额：</label>
        <span>{{examineInfo.order.mcn_rebate}}</span>
        <em v-if="examineInfo.order_origin.mcn_rebate || examineInfo.order_origin.mcn_rebate == ''">原值：{{examineInfo.order_origin.mcn_rebate}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.offline_cost_invoice_date || examineInfo.order_origin.offline_cost_invoice_date == '') ? 'change':''">
        <label>线下成本发票日期：</label>
        <span>{{examineInfo.order.offline_cost_invoice_date}}</span>
        <em v-if="examineInfo.order_origin.offline_cost_invoice_date || examineInfo.order_origin.offline_cost_invoice_date == ''">原值：{{examineInfo.order_origin.offline_cost_invoice_date}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.mcn_handler || examineInfo.order_origin.mcn_handler == '') ? 'change':''">
        <label>mcn经手人：</label>
        <span>{{examineInfo.order.mcn_handler}}</span>
        <em v-if="examineInfo.order_origin.mcn_handler || examineInfo.order_origin.mcn_handler == ''">原值：{{examineInfo.order_origin.mcn_handler}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.mcn_handler_id || examineInfo.order_origin.mcn_handler_id == '') ? 'change':''">
        <label>mcn经手人ID：</label>
        <span>{{examineInfo.order.mcn_handler_id}}</span>
        <em v-if="examineInfo.order_origin.mcn_handler_id || examineInfo.order_origin.mcn_handler_id == ''">原值：{{examineInfo.order_origin.mcn_handler_id}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.offline_cost_invoice_amount || examineInfo.order_origin.offline_cost_invoice_amount == '') ? 'change':''">
        <label>线下成本发票金额：</label>
        <span>{{examineInfo.order.offline_cost_invoice_amount}}</span>
        <em v-if="examineInfo.order_origin.offline_cost_invoice_amount || examineInfo.order_origin.offline_cost_invoice_amount == ''">原值：{{examineInfo.order_origin.offline_cost_invoice_amount}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.cost_company_name || examineInfo.order_origin.cost_company_name == '') ? 'change':''">
        <label>成本公司全称：</label>
        <span>{{examineInfo.order.cost_company_name}}</span>
        <em v-if="examineInfo.order_origin.cost_company_name || examineInfo.order_origin.cost_company_name == ''">原值：{{examineInfo.order_origin.cost_company_name}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.cost_owner || examineInfo.order_origin.cost_owner == '') ? 'change':''">
        <label>成本负责人：</label>
        <span>{{examineInfo.order.cost_owner}}</span>
        <em v-if="examineInfo.order_origin.cost_owner || examineInfo.order_origin.cost_owner == ''">原值：{{examineInfo.order_origin.cost_owner}}</em>
      </div>
    </div>
    <div class="writeBox">
      <div class="writeItem" :class="(examineInfo.order_origin.actual_cost_sum || examineInfo.order_origin.actual_cost_sum == '') ? 'change':''">
        <label>后台实付成本金额：</label>
        <span>{{examineInfo.order.actual_cost_sum}}</span>
        <em v-if="examineInfo.order_origin.actual_cost_sum || examineInfo.order_origin.actual_cost_sum == ''">原值：{{examineInfo.order_origin.actual_cost_sum}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.rebate || examineInfo.order_origin.rebate == '') ? 'change':''">
        <label>补款总额(含税)：</label>
        <span>{{examineInfo.order.rebate}}</span>
        <em v-if="examineInfo.order_origin.rebate || examineInfo.order_origin.rebate == ''">原值：{{examineInfo.order_origin.rebate}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.ratio_of_consumption_to_top_rebate || examineInfo.order_origin.ratio_of_consumption_to_top_rebate == '') ? 'change':''">
        <label>预估总消耗与置顶返点比例：</label>
        <span>{{examineInfo.order.ratio_of_consumption_to_top_rebate}}</span>
        <em v-if="examineInfo.order_origin.ratio_of_consumption_to_top_rebate || examineInfo.order_origin.ratio_of_consumption_to_top_rebate == ''">原值：{{examineInfo.order_origin.ratio_of_consumption_to_top_rebate}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.ratio_of_consumption_to_top_income || examineInfo.order_origin.ratio_of_consumption_to_top_income == '') ? 'change':''">
        <label>预估总消耗与置顶返点收入：</label>
        <span>{{examineInfo.order.ratio_of_consumption_to_top_income}}</span>
        <em v-if="examineInfo.order_origin.ratio_of_consumption_to_top_income || examineInfo.order_origin.ratio_of_consumption_to_top_income == ''">原值：{{examineInfo.order_origin.ratio_of_consumption_to_top_income}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.flow_boost_rebate_ratio || examineInfo.order_origin.flow_boost_rebate_ratio == '') ? 'change':''">
        <label>预估总流量助推返点比例：</label>
        <span>{{examineInfo.order.flow_boost_rebate_ratio}}</span>
        <em v-if="examineInfo.order_origin.flow_boost_rebate_ratio || examineInfo.order_origin.flow_boost_rebate_ratio == ''">原值：{{examineInfo.order_origin.flow_boost_rebate_ratio}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.flow_boost_rebate_income || examineInfo.order_origin.flow_boost_rebate_income == '') ? 'change':''">
        <label>预估总流量助推返点收入：</label>
        <span>{{examineInfo.order.flow_boost_rebate_income}}</span>
        <em v-if="examineInfo.order_origin.flow_boost_rebate_income || examineInfo.order_origin.flow_boost_rebate_income == ''">原值：{{examineInfo.order_origin.flow_boost_rebate_income}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.rebate_spending_amount || examineInfo.order_origin.rebate_spending_amount == '') ? 'change':''">
        <label>返点支出金额：</label>
        <span>{{examineInfo.order.rebate_spending_amount}}</span>
        <em v-if="examineInfo.order_origin.rebate_spending_amount || examineInfo.order_origin.rebate_spending_amount == ''">原值：{{examineInfo.order_origin.rebate_spending_amount}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.actual_cost || examineInfo.order_origin.actual_cost == '') ? 'change':''">
        <label>当月实际消耗成本金额：</label>
        <span>{{examineInfo.order.actual_cost}}</span>
        <em v-if="examineInfo.order_origin.actual_cost || examineInfo.order_origin.actual_cost == ''">原值：{{examineInfo.order_origin.actual_cost}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.profit || examineInfo.order_origin.profit == '') ? 'change':''">
        <label>当月毛利：</label>
        <span>{{examineInfo.order.profit}}</span>
        <em v-if="examineInfo.order_origin.profit || examineInfo.order_origin.profit == ''">原值：{{examineInfo.order_origin.profit}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.gross_margin || examineInfo.order_origin.gross_margin == '') ? 'change':''">
        <label>毛利率：</label>
        <span>{{examineInfo.order.gross_margin}}</span>
        <em v-if="examineInfo.order_origin.gross_margin || examineInfo.order_origin.gross_margin == ''">原值：{{examineInfo.order_origin.gross_margin}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.rebate_amount_receivable || examineInfo.order_origin.rebate_amount_receivable == '') ? 'change':''">
        <label>应收返点金额：</label>
        <span>{{examineInfo.order.rebate_amount_receivable}}</span>
        <em v-if="examineInfo.order_origin.rebate_amount_receivable || examineInfo.order_origin.rebate_amount_receivable == ''">原值：{{examineInfo.order_origin.rebate_amount_receivable}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.rebate_amount_payable || examineInfo.order_origin.rebate_amount_payable == '') ? 'change':''">
        <label>应付返点金额：</label>
        <span>{{examineInfo.order.rebate_amount_payable}}</span>
        <em v-if="examineInfo.order_origin.rebate_amount_payable || examineInfo.order_origin.rebate_amount_payable == ''">原值：{{examineInfo.order_origin.rebate_amount_payable}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.tax_free_amount || examineInfo.order_origin.tax_free_amount == '') ? 'change':''">
        <label>不含税金额：</label>
        <span>{{examineInfo.order.tax_free_amount}}</span>
        <em v-if="examineInfo.order_origin.tax_free_amount || examineInfo.order_origin.tax_free_amount == ''">原值：{{examineInfo.order_origin.tax_free_amount}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.rebate_total || examineInfo.order_origin.rebate_total == '') ? 'change':''">
        <label>已开票返点合计：</label>
        <span>{{examineInfo.order.rebate_total}}</span>
        <em v-if="examineInfo.order_origin.rebate_total || examineInfo.order_origin.rebate_total == ''">原值：{{examineInfo.order_origin.rebate_total}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.estimate_cost || examineInfo.order_origin.estimate_cost == '') ? 'change':''">
        <label>暂估成本金额：</label>
        <span>{{examineInfo.order.estimate_cost}}</span>
        <em v-if="examineInfo.order_origin.estimate_cost || examineInfo.order_origin.estimate_cost == ''">原值：{{examineInfo.order_origin.estimate_cost}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.estimate_traffic_boost_refund || examineInfo.order_origin.estimate_traffic_boost_refund == '') ? 'change':''">
        <label>暂估流量助推（返货）成本：</label>
        <span>{{examineInfo.order.estimate_traffic_boost_refund}}</span>
        <em v-if="examineInfo.order_origin.estimate_traffic_boost_refund || examineInfo.order_origin.estimate_traffic_boost_refund == ''">原值：{{examineInfo.order_origin.estimate_traffic_boost_refund}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.cost_invoice_date || examineInfo.order_origin.cost_invoice_date == '') ? 'change':''">
        <label>成本开票日期：</label>
        <span>{{examineInfo.order.cost_invoice_date}}</span>
        <em v-if="examineInfo.order_origin.cost_invoice_date || examineInfo.order_origin.cost_invoice_date == ''">原值：{{examineInfo.order_origin.cost_invoice_date}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.final_ratio_of_consumption_to_top_rebate || examineInfo.order_origin.final_ratio_of_consumption_to_top_rebate == '') ? 'change':''">
        <label>已开票消耗与置顶返点比例：</label>
        <span>{{examineInfo.order.final_ratio_of_consumption_to_top_rebate}}</span>
        <em v-if="examineInfo.order_origin.final_ratio_of_consumption_to_top_rebate || examineInfo.order_origin.final_ratio_of_consumption_to_top_rebate == ''">原值：{{examineInfo.order_origin.final_ratio_of_consumption_to_top_rebate}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.final_ratio_of_consumption_to_top_income || examineInfo.order_origin.final_ratio_of_consumption_to_top_income == '') ? 'change':''">
        <label>已开票消耗与置顶返点收入：</label>
        <span>{{examineInfo.order.final_ratio_of_consumption_to_top_income}}</span>
        <em v-if="examineInfo.order_origin.final_ratio_of_consumption_to_top_income || examineInfo.order_origin.final_ratio_of_consumption_to_top_income == ''">原值：{{examineInfo.order_origin.final_ratio_of_consumption_to_top_income}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.final_flow_boost_rebate_ratio || examineInfo.order_origin.final_flow_boost_rebate_ratio == '') ? 'change':''">
        <label>已开票流量助推返点比例：</label>
        <span>{{examineInfo.order.final_flow_boost_rebate_ratio}}</span>
        <em v-if="examineInfo.order_origin.final_flow_boost_rebate_ratio || examineInfo.order_origin.final_flow_boost_rebate_ratio == ''">原值：{{examineInfo.order_origin.final_flow_boost_rebate_ratio}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.final_flow_boost_rebate_income || examineInfo.order_origin.final_flow_boost_rebate_income == '') ? 'change':''">
        <label>已开票流量助推返点收入：</label>
        <span>{{examineInfo.order.final_flow_boost_rebate_income}}</span>
        <em v-if="examineInfo.order_origin.final_flow_boost_rebate_income || examineInfo.order_origin.final_flow_boost_rebate_income == ''">原值：{{examineInfo.order_origin.final_flow_boost_rebate_income}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.red_invoice_date || examineInfo.order_origin.red_invoice_date == '') ? 'change':''">
        <label>红字发票日期：</label>
        <span>{{examineInfo.order.red_invoice_date}}</span>
        <em v-if="examineInfo.order_origin.red_invoice_date || examineInfo.order_origin.red_invoice_date == ''">原值：{{examineInfo.order_origin.red_invoice_date}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.refund_invoice_date || examineInfo.order_origin.refund_invoice_date == '') ? 'change':''">
        <label>返点发票日期：</label>
        <span>{{examineInfo.order.refund_invoice_date}}</span>
        <em v-if="examineInfo.order_origin.refund_invoice_date || examineInfo.order_origin.refund_invoice_date == ''">原值：{{examineInfo.order_origin.refund_invoice_date}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.estimate_rebate_total || examineInfo.order_origin.estimate_rebate_total == '') ? 'change':''">
        <label>预估总返点合计：</label>
        <span>{{examineInfo.order.estimate_rebate_total}}</span>
        <em v-if="examineInfo.order_origin.estimate_rebate_total || examineInfo.order_origin.estimate_rebate_total == ''">原值：{{examineInfo.order_origin.estimate_rebate_total}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.rebate_total || examineInfo.order_origin.rebate_total == '') ? 'change':''">
        <label>已开票返点合计：</label>
        <span>{{examineInfo.order.rebate_total}}</span>
        <em v-if="examineInfo.order_origin.rebate_total || examineInfo.order_origin.rebate_total == ''">原值：{{examineInfo.order_origin.rebate_total}}</em>
      </div>
      <!-- <div class="writeItem" :class="(examineInfo.order_origin.offline_invoice_date || examineInfo.order_origin.offline_invoice_date == '') ? 'change':''">
        <label>线下补款开票日期：</label>
        <span>{{examineInfo.order.offline_invoice_date}}</span>
        <em v-if="examineInfo.order_origin.offline_invoice_date || examineInfo.order_origin.offline_invoice_date == ''">原值：{{examineInfo.order_origin.offline_invoice_date}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.offline_confirmed_cost_includes_tax || examineInfo.order_origin.offline_confirmed_cost_includes_tax == '') ? 'change':''">
        <label>线下确认成本（含税）发票金额：</label>
        <span>{{examineInfo.order.offline_confirmed_cost_includes_tax}}</span>
        <em v-if="examineInfo.order_origin.offline_confirmed_cost_includes_tax || examineInfo.order_origin.offline_confirmed_cost_includes_tax == ''">原值：{{examineInfo.order_origin.offline_confirmed_cost_includes_tax}}</em>
      </div> -->
      <div class="writeItem" :class="(examineInfo.order_origin.offline_confirmed_cost || examineInfo.order_origin.offline_confirmed_cost == '') ? 'change':''">
        <label>线下确认成本（不含税）：</label>
        <span>{{examineInfo.order.offline_confirmed_cost}}</span>
        <em v-if="examineInfo.order_origin.offline_confirmed_cost || examineInfo.order_origin.offline_confirmed_cost == ''">原值：{{examineInfo.order_origin.offline_confirmed_cost}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.offline_celeb_name || examineInfo.order_origin.offline_celeb_name == '') ? 'change':''">
        <label>线下补款收款人姓名：</label>
        <span>{{examineInfo.order.offline_celeb_name}}</span>
        <em v-if="examineInfo.order_origin.offline_celeb_name || examineInfo.order_origin.offline_celeb_name == ''">原值：{{examineInfo.order_origin.offline_celeb_name}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.offline_pay_date || examineInfo.order_origin.offline_pay_date == '') ? 'change':''">
        <label>线下付款日期：</label>
        <span>{{examineInfo.order.offline_pay_date}}</span>
        <em v-if="examineInfo.order_origin.offline_pay_date || examineInfo.order_origin.offline_pay_date == ''">原值：{{examineInfo.order_origin.offline_pay_date}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.offline_subsidy_company || examineInfo.order_origin.offline_subsidy_company == '') ? 'change':''">
        <label>线下付款公司：</label>
        <span>{{examineInfo.order.offline_subsidy_company}}</span>
        <em v-if="examineInfo.order_origin.offline_subsidy_company || examineInfo.order_origin.offline_subsidy_company == ''">原值：{{examineInfo.order_origin.offline_subsidy_company}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.offline_subsidy_amount || examineInfo.order_origin.offline_subsidy_amount == '') ? 'change':''">
        <label>线下补款金额：</label>
        <span>{{examineInfo.order.offline_subsidy_amount}}</span>
        <em v-if="examineInfo.order_origin.offline_subsidy_amount || examineInfo.order_origin.offline_subsidy_amount == ''">原值：{{examineInfo.order_origin.offline_subsidy_amount}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.final_customer_name || examineInfo.order_origin.final_customer_name == '') ? 'change':''">
        <label>穿透最终客户名称：</label>
        <span>{{examineInfo.order.final_customer_name}}</span>
        <em v-if="examineInfo.order_origin.final_customer_name || examineInfo.order_origin.final_customer_name == ''">原值：{{examineInfo.order_origin.final_customer_name}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.estimated_amount || examineInfo.order_origin.estimated_amount == '') ? 'change':''">
        <label>暂估收入金额：</label>
        <span>{{examineInfo.order.estimated_amount}}</span>
        <em v-if="examineInfo.order_origin.estimated_amount || examineInfo.order_origin.estimated_amount == ''">原值：{{examineInfo.order_origin.estimated_amount}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.customer_rebate || examineInfo.order_origin.customer_rebate == '') ? 'change':''">
        <label>客户返点(净额)：</label>
        <span>{{examineInfo.order.customer_rebate}}</span>
        <em v-if="examineInfo.order_origin.customer_rebate || examineInfo.order_origin.customer_rebate == ''">原值：{{examineInfo.order_origin.customer_rebate}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.actual_consumption_rebate_ratio || examineInfo.order_origin.actual_consumption_rebate_ratio == '') ? 'change':''">
        <label>实际消耗返点比例(客户折扣比例)：</label>
        <span>{{examineInfo.order.actual_consumption_rebate_ratio}}</span>
        <em v-if="examineInfo.order_origin.actual_consumption_rebate_ratio || examineInfo.order_origin.actual_consumption_rebate_ratio == ''">原值：{{examineInfo.order_origin.actual_consumption_rebate_ratio}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.link_fee_rebate_ratio || examineInfo.order_origin.link_fee_rebate_ratio == '') ? 'change':''">
        <label>链接费返点比例(客户折扣比例)：</label>
        <span>{{examineInfo.order.link_fee_rebate_ratio}}</span>
        <em v-if="examineInfo.order_origin.link_fee_rebate_ratio || examineInfo.order_origin.link_fee_rebate_ratio == ''">原值：{{examineInfo.order_origin.link_fee_rebate_ratio}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.flow_boost_back_point_ratio || examineInfo.order_origin.flow_boost_back_point_ratio == '') ? 'change':''">
        <label>流量助推返点比例(客户折扣比例)：</label>
        <span>{{examineInfo.order.flow_boost_back_point_ratio}}</span>
        <em v-if="examineInfo.order_origin.flow_boost_back_point_ratio || examineInfo.order_origin.flow_boost_back_point_ratio == ''">原值：{{examineInfo.order_origin.flow_boost_back_point_ratio}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.top_fee_rebate_proportion || examineInfo.order_origin.top_fee_rebate_proportion == '') ? 'change':''">
        <label>置顶费返点比例(客户折扣比例)：</label>
        <span>{{examineInfo.order.top_fee_rebate_proportion}}</span>
        <em v-if="examineInfo.order_origin.top_fee_rebate_proportion || examineInfo.order_origin.top_fee_rebate_proportion == ''">原值：{{examineInfo.order_origin.top_fee_rebate_proportion}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.actual_consumption_before || examineInfo.order_origin.actual_consumption_before == '') ? 'change':''">
        <label>实际消耗(收入折分前项)：</label>
        <span>{{examineInfo.order.actual_consumption_before}}</span>
        <em v-if="examineInfo.order_origin.actual_consumption_before || examineInfo.order_origin.actual_consumption_before == ''">原值：{{examineInfo.order_origin.actual_consumption_before}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.link_fee_before || examineInfo.order_origin.link_fee_before == '') ? 'change':''">
        <label>链接费(收入折分前项)：</label>
        <span>{{examineInfo.order.link_fee_before}}</span>
        <em v-if="examineInfo.order_origin.link_fee_before || examineInfo.order_origin.link_fee_before == ''">原值：{{examineInfo.order_origin.link_fee_before}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.flow_boost_back_point_before || examineInfo.order_origin.flow_boost_back_point_before == '') ? 'change':''">
        <label>量助推(收入折分前项)：</label>
        <span>{{examineInfo.order.flow_boost_back_point_before}}</span>
        <em v-if="examineInfo.order_origin.flow_boost_back_point_before || examineInfo.order_origin.flow_boost_back_point_before == ''">原值：{{examineInfo.order_origin.flow_boost_back_point_before}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.top_fee_before || examineInfo.order_origin.top_fee_before == '') ? 'change':''">
        <label>置顶费(收入折分前项)：</label>
        <span>{{examineInfo.order.top_fee_before}}</span>
        <em v-if="examineInfo.order_origin.top_fee_before || examineInfo.order_origin.top_fee_before == ''">原值：{{examineInfo.order_origin.top_fee_before}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.before_folding_combined || examineInfo.order_origin.before_folding_combined == '') ? 'change':''">
        <label>折前合计：</label>
        <span>{{examineInfo.order.before_folding_combined}}</span>
        <em v-if="examineInfo.order_origin.before_folding_combined || examineInfo.order_origin.before_folding_combined == ''">原值：{{examineInfo.order_origin.before_folding_combined}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.actual_consumption_after || examineInfo.order_origin.actual_consumption_after == '') ? 'change':''">
        <label>实际消耗(收入折分后项)：</label>
        <span>{{examineInfo.order.actual_consumption_after}}</span>
        <em v-if="examineInfo.order_origin.actual_consumption_after || examineInfo.order_origin.actual_consumption_after == ''">原值：{{examineInfo.order_origin.actual_consumption_after}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.link_fee_after || examineInfo.order_origin.link_fee_after == '') ? 'change':''">
        <label>链接费(收入折分后项)：</label>
        <span>{{examineInfo.order.link_fee_after}}</span>
        <em v-if="examineInfo.order_origin.link_fee_after || examineInfo.order_origin.link_fee_after == ''">原值：{{examineInfo.order_origin.link_fee_after}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.flow_boost_back_point_after || examineInfo.order_origin.flow_boost_back_point_after == '') ? 'change':''">
        <label>流量助推(收入折后项)：</label>
        <span>{{examineInfo.order.flow_boost_back_point_after}}</span>
        <em v-if="examineInfo.order_origin.flow_boost_back_point_after || examineInfo.order_origin.flow_boost_back_point_after == ''">原值：{{examineInfo.order_origin.flow_boost_back_point_after}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.top_fee_after || examineInfo.order_origin.top_fee_after == '') ? 'change':''">
        <label>置顶费(收入折后项)：</label>
        <span>{{examineInfo.order.top_fee_after}}</span>
        <em v-if="examineInfo.order_origin.top_fee_after || examineInfo.order_origin.top_fee_after == ''">原值：{{examineInfo.order_origin.top_fee_after}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.discounted_combined || examineInfo.order_origin.discounted_combined == '') ? 'change':''">
        <label>折后合计：</label>
        <span>{{examineInfo.order.discounted_combined}}</span>
        <em v-if="examineInfo.order_origin.discounted_combined || examineInfo.order_origin.discounted_combined == ''">原值：{{examineInfo.order_origin.discounted_combined}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.cpa_unit_income_price || examineInfo.order_origin.cpa_unit_income_price == '') ? 'change':''">
        <label>cpa收入单价：</label>
        <span>{{examineInfo.order.cpa_unit_income_price}}</span>
        <em v-if="examineInfo.order_origin.cpa_unit_income_price || examineInfo.order_origin.cpa_unit_income_price == ''">原值：{{examineInfo.order_origin.cpa_unit_income_price}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.cpa_single_quantity || examineInfo.order_origin.cpa_single_quantity == '') ? 'change':''">
        <label>cpa单量：</label>
        <span>{{examineInfo.order.cpa_single_quantity}}</span>
        <em v-if="examineInfo.order_origin.cpa_single_quantity || examineInfo.order_origin.cpa_single_quantity == ''">原值：{{examineInfo.order_origin.cpa_single_quantity}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.income_red_invoice_date || examineInfo.order_origin.income_red_invoice_date == '') ? 'change':''">
        <label>开具红字发票日期：</label>
        <span>{{examineInfo.order.income_red_invoice_date}}</span>
        <em v-if="examineInfo.order_origin.income_red_invoice_date || examineInfo.order_origin.income_red_invoice_date == ''">原值：{{examineInfo.order_origin.income_red_invoice_date}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.income_red_invoice_amount || examineInfo.order_origin.income_red_invoice_amount == '') ? 'change':''">
        <label>开具红字发票金额：</label>
        <span>{{examineInfo.order.income_red_invoice_amount}}</span>
        <em v-if="examineInfo.order_origin.income_red_invoice_amount || examineInfo.order_origin.income_red_invoice_amount == ''">原值：{{examineInfo.order_origin.income_red_invoice_amount}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.agreed_rebate_percentage || examineInfo.order_origin.agreed_rebate_percentage == '') ? 'change':''">
        <label>约定的返点比例：</label>
        <span>{{examineInfo.order.agreed_rebate_percentage}}</span>
        <em v-if="examineInfo.order_origin.agreed_rebate_percentage || examineInfo.order_origin.agreed_rebate_percentage == ''">原值：{{examineInfo.order_origin.agreed_rebate_percentage}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.organization_amount || examineInfo.order_origin.organization_amount == '') ? 'change':''">
        <label>机构到手金额：</label>
        <span>{{examineInfo.order.organization_amount}}</span>
        <em v-if="examineInfo.order_origin.organization_amount || examineInfo.order_origin.organization_amount == ''">原值：{{examineInfo.order_origin.organization_amount}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.mcn_final_amount || examineInfo.order_origin.mcn_final_amount == '') ? 'change':''">
        <label>mcn最终收入金额：</label>
        <span>{{examineInfo.order.mcn_final_amount}}</span>
        <em v-if="examineInfo.order_origin.mcn_final_amount || examineInfo.order_origin.mcn_final_amount == ''">原值：{{examineInfo.order_origin.mcn_final_amount}}</em>
      </div>
    </div>
    <!-- 财务填写 -->
    <div class="writeBox">
      <p class="title">财务填写</p>

      <!-- <div class="writeItem" :class="(examineInfo.order_origin.confirmation_certificate || examineInfo.order_origin.confirmation_certificate == '') ? 'change':''">
                <label>确认凭证：</label>
                <span>{{examineInfo.order.confirmation_certificate}}</span>
                <em v-if="examineInfo.order_origin.confirmation_certificate || examineInfo.order_origin.confirmation_certificate == ''">原值：{{examineInfo.order_origin.confirmation_certificate}}</em>
            </div> -->
      <div class="writeItem" :class="(examineInfo.order_origin.confirmed_cost_includes_tax || examineInfo.order_origin.confirmed_cost_includes_tax == '') ? 'change':''">
        <label>确认成本(含税)：</label>
        <span>{{examineInfo.order.confirmed_cost_includes_tax}}</span>
        <em v-if="examineInfo.order_origin.confirmed_cost_includes_tax || examineInfo.order_origin.confirmed_cost_includes_tax == ''">原值：{{examineInfo.order_origin.confirmed_cost_includes_tax}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.document_number_first || examineInfo.order_origin.document_number_first == '') ? 'change':''">
        <label style="font-size:12px">凭证号1(收入暂估凭证)：</label>
        <span>{{examineInfo.order.document_number_first}}</span>
        <em v-if="examineInfo.order_origin.document_number_first || examineInfo.order_origin.document_number_first == ''">原值：{{examineInfo.order_origin.document_number_first}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.confirmed_cost || examineInfo.order_origin.confirmed_cost == '') ? 'change':''">
        <label>确认成本(不含税)：</label>
        <span>{{examineInfo.order.confirmed_cost}}</span>
        <em v-if="examineInfo.order_origin.confirmed_cost || examineInfo.order_origin.confirmed_cost == ''">原值：{{examineInfo.order_origin.confirmed_cost}}</em>
      </div>
      <!-- <div class="writeItem" :class="(examineInfo.order_origin.unbilled_voucher || examineInfo.order_origin.unbilled_voucher == '') ? 'change':''">
                <label>未开票凭证：</label>
                <span>{{examineInfo.order.unbilled_voucher}}</span>
                <em v-if="examineInfo.order_origin.unbilled_voucher || examineInfo.order_origin.unbilled_voucher == ''">原值：{{examineInfo.order_origin.unbilled_voucher}}</em>
            </div> -->
      <div class="writeItem" :class="(examineInfo.order_origin.document_number_second || examineInfo.order_origin.document_number_second == '') ? 'change':''">
        <label style="font-size:12px">凭证号2(流量助推合计暂估凭证)：</label>
        <span>{{examineInfo.order.document_number_second}}</span>
        <em v-if="examineInfo.order_origin.document_number_second || examineInfo.order_origin.document_number_second == ''">原值：{{examineInfo.order_origin.document_number_second}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.confirmation_certificate_first || examineInfo.order_origin.confirmation_certificate_first == '') ? 'change':''">
        <label style="font-size:12px">收入确认凭证：</label>
        <span>{{examineInfo.order.confirmation_certificate_first}}</span>
        <em v-if="examineInfo.order_origin.confirmation_certificate_first || examineInfo.order_origin.confirmation_certificate_first == ''">原值：{{examineInfo.order_origin.confirmation_certificate_first}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.document_number_third || examineInfo.order_origin.document_number_third == '') ? 'change':''">
        <label style="font-size:12px">凭证号3(后台实付成本合计暂估凭证)：</label>
        <span>{{examineInfo.order.document_number_third}}</span>
        <em v-if="examineInfo.order_origin.document_number_third || examineInfo.order_origin.document_number_third == ''">原值：{{examineInfo.order_origin.document_number_third}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.confirmation_certificate_third || examineInfo.order_origin.confirmation_certificate_third == '') ? 'change':''">
        <label style="font-size:12px">确认成本凭证：</label>
        <span>{{examineInfo.order.confirmation_certificate_third}}</span>
        <em v-if="examineInfo.order_origin.confirmation_certificate_third || examineInfo.order_origin.confirmation_certificate_third == ''">原值：{{examineInfo.order_origin.confirmation_certificate_third}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.document_number_four || examineInfo.order_origin.document_number_four == '') ? 'change':''">
        <label style="font-size:12px">凭证号4(补款暂估凭证)：</label>
        <span>{{examineInfo.order.document_number_four}}</span>
        <em v-if="examineInfo.order_origin.document_number_four || examineInfo.order_origin.document_number_four == ''">原值：{{examineInfo.order_origin.document_number_four}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.confirmation_certificate_four || examineInfo.order_origin.confirmation_certificate_four == '') ? 'change':''">
        <label style="font-size:12px">补款确认凭证：</label>
        <span>{{examineInfo.order.confirmation_certificate_four}}</span>
        <em v-if="examineInfo.order_origin.confirmation_certificate_four || examineInfo.order_origin.confirmation_certificate_four == ''">原值：{{examineInfo.order_origin.confirmation_certificate_four}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.document_number_five || examineInfo.order_origin.document_number_five == '') ? 'change':''">
        <label style="font-size:12px">凭证号5(消耗与置顶返点收入暂估凭证)：</label>
        <span>{{examineInfo.order.document_number_five}}</span>
        <em v-if="examineInfo.order_origin.document_number_five || examineInfo.order_origin.document_number_five == ''">原值：{{examineInfo.order_origin.document_number_five}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.confirmation_certificate_five || examineInfo.order_origin.confirmation_certificate_five == '') ? 'change':''">
        <label style="font-size:12px">消耗与置顶返点收入确认凭证：</label>
        <span>{{examineInfo.order.confirmation_certificate_five}}</span>
        <em v-if="examineInfo.order_origin.confirmation_certificate_five || examineInfo.order_origin.confirmation_certificate_five == ''">原值：{{examineInfo.order_origin.confirmation_certificate_five}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.document_number_six || examineInfo.order_origin.document_number_six == '') ? 'change':''">
        <label style="font-size:12px">凭证号6(流量助推返点收入暂估凭证)：</label>
        <span>{{examineInfo.order.document_number_six}}</span>
        <em v-if="examineInfo.order_origin.document_number_six || examineInfo.order_origin.document_number_six == ''">原值：{{examineInfo.order_origin.document_number_six}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.confirmation_certificate_six || examineInfo.order_origin.confirmation_certificate_six == '') ? 'change':''">
        <label style="font-size:12px">流量助推返点收入确认凭证：</label>
        <span>{{examineInfo.order.confirmation_certificate_six}}</span>
        <em v-if="examineInfo.order_origin.confirmation_certificate_six || examineInfo.order_origin.confirmation_certificate_six == ''">原值：{{examineInfo.order_origin.confirmation_certificate_six}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.document_number_seven || examineInfo.order_origin.document_number_seven == '') ? 'change':''">
        <label style="font-size:12px">凭证号7(返点支出暂估凭证)：</label>
        <span>{{examineInfo.order.document_number_seven}}</span>
        <em v-if="examineInfo.order_origin.document_number_seven || examineInfo.order_origin.document_number_seven == ''">原值：{{examineInfo.order_origin.document_number_seven}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.confirmation_certificate_seven || examineInfo.order_origin.confirmation_certificate_seven == '') ? 'change':''">
        <label style="font-size:12px">返点支出确认凭证：</label>
        <span>{{examineInfo.order.confirmation_certificate_seven}}</span>
        <em v-if="examineInfo.order_origin.confirmation_certificate_seven || examineInfo.order_origin.confirmation_certificate_seven == ''">原值：{{examineInfo.order_origin.confirmation_certificate_seven}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.cost_invoice_status || examineInfo.order_origin.cost_invoice_status == '') ? 'change':''">
        <label>成本发票情况：</label>
        <span>{{examineInfo.order.cost_invoice_status}}</span>
        <em v-if="examineInfo.order_origin.cost_invoice_status || examineInfo.order_origin.cost_invoice_status == ''">原值：{{examineInfo.order_origin.cost_invoice_status}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.mcn_document_number || examineInfo.order_origin.mcn_document_number == '') ? 'change':''">
        <label>mcn凭证号：</label>
        <span>{{examineInfo.order.mcn_document_number}}</span>
        <em v-if="examineInfo.order_origin.mcn_document_number || examineInfo.order_origin.mcn_document_number == ''">原值：{{examineInfo.order_origin.mcn_document_number}}</em>
      </div>
      <div class="writeItem" :class="(examineInfo.order_origin.mcn_confirmation_certificate || examineInfo.order_origin.mcn_confirmation_certificate == '') ? 'change':''">
        <label>mcn确认凭证号：</label>
        <span>{{examineInfo.order.mcn_confirmation_certificate}}</span>
        <em v-if="examineInfo.order_origin.mcn_confirmation_certificate || examineInfo.order_origin.mcn_confirmation_certificate == ''">原值：{{examineInfo.order_origin.mcn_confirmation_certificate}}</em>
      </div>
    </div>
    <div class="writeBox">
      <div class="writeItem" style="width:100%">
        <label>修改内容:</label>
        <span>{{examineInfo.content}}</span>
      </div>
      <div class="writeItem">
        <label>修改者:</label>
        <span>{{examineInfo.op_user_name}}</span>
      </div>
      <div class="writeItem">
        <label>修改者角色:</label>
        <span>{{examineInfo.op_user_role}}</span>
      </div>
      <div class="writeItem">
        <label>提交修改时间:</label>
        <span>{{examineInfo.created_at}}</span>
      </div>
      <div class="writeItem" style="width:100%">
        <label>修改者原因:</label>
        <span>{{examineInfo.op_reason}}</span>
      </div>
    </div>
    <div class="writeBox" v-if="examineInfo.mj_status&&examineInfo.mj_status!=0">
      <div class="writeItem">
        <label>媒介审核人:</label>
        <span>{{examineInfo.verify_user_name}}</span>
      </div>
      <div class="writeItem">
        <label>媒介审核时间:</label>
        <span>{{examineInfo.verify_at}}</span>
      </div>
      <div class="writeItem" style="width:100%">
        <label>媒介审核意见:</label>
        <span>{{examineInfo.verify_note}}</span>
      </div>
    </div>
    <div class="writeBox" v-if="userInfo.role_id == 18 && examineInfo.pre_audit_status || (userInfo.role_id == 10 || userInfo.role_id == 17 || userInfo.role_id == 21)">
      <div class="writeItem" style="width:100%">
        <label>预审:</label>
        <span>{{ examineInfo.pre_audit_status == 1 ? '通过' : examineInfo.pre_audit_status == 2 ? '驳回' : '' }}</span>
      </div>
      <div class="writeItem" style="width:100%">
        <label>预审意见:</label>
        <span>{{ examineInfo.pre_audit_content}}</span>
      </div>
    </div>
    <!-- 财务预审 -->
    <template v-if="userInfo.role_id == 18">
      <template v-if="!examineInfo.pre_audit_status">
        <div class="writeBox">
            <p class="title">预审</p>
            <el-radio-group v-model="preAudit.status">
              <el-radio :label="1">通过</el-radio>
              <el-radio :label="2">驳回</el-radio>
            </el-radio-group>
            <p class="title">预审意见</p>
            <div class="writeItem" style="width:90%">
                <el-input class="input" type="textarea" maxlength="300" v-model.trim="preAudit.content" placeholder="请输入审核意见" size='mini'></el-input>
            </div>
        </div>
        <div class="buttones">
            <button class="yes" @click="preAuditSubmit">提交</button>
            <button @click="orderCancelClick">取消</button>
        </div>
      </template>
      <div class="buttones" v-else>
          <button @click="orderCancelClick">取消</button>
      </div>
    </template>
    <template v-if="userInfo.role_id != 18">
      <div class="writeBox">
        <p class="title">审核意见</p>
        <div class="writeItem" style="width:90%">
          <el-input class="input" type="textarea" v-model.trim="verify_note" placeholder="请输入审核意见" size='mini'></el-input>
        </div>
      </div>
      <div class="buttones">
        <button class="yes" @click="verifyEvent(1)">审核通过</button>
        <button class="yes" style="background:#d51313;border-color:#d51313;" @click="verifyEvent(0)">审核不通过</button>
        <button @click="orderCancelClick">取消</button>
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: ['examineInfo'],
  data () {
    return {
      loading: false,
      userInfo: {},
      verify_note: '',//修改原因
      preAudit: {//财务预审
        status: '',
        content: ''
      }
    }
  },
  created () {
    this.userInfo = JSON.parse(this.$cookie.getCookie('userInfo'));
  },
  mounted(){
    this.getPreAudit()
  },
  methods: {
    // 获取预审结果
    getPreAudit(){
      this.preAudit.status = this.examineInfo.pre_audit_status;
      this.preAudit.content = this.examineInfo.pre_audit_content;
    },
    /**提交预审 */
    preAuditSubmit(){
      if (this.preAudit.status == '' || !this.preAudit.status) {
        this.$message.warning('请选择预审结果')
        return
      }
      if (this.preAudit.status == 2 && (this.preAudit.content == '' || !this.preAudit.content)) {
        this.$message.warning('请输入审核意见')
        return
      }
      this.loading = true;
      this.$axios.post(this.URL.BASEURL + this.URL.preAuditRecordSave,{
          type: 1,
          data_id_list: [ this.examineInfo.id ],
          status: this.preAudit.status,
          content: this.preAudit.content,
      }).then((res) => {
          var res=res.data;
          if(res&& res.errno == 0){
              this.$emit('emit_refresh')
          }else {
              this.loading = false;
              this.$message({
                  message: res.err,
                  type: 'warning'
              })
          }
      }).catch(()=>{
          this.loading = false;
      })
    },
    verifyEvent (source) {
      if (source != 1 && this.verify_note == '') {
        this.$message({
          message: '请输入审核意见',
          type: 'warning'
        })
        return;
      }
      this.$confirm(source == 1 ? '确定审核通过该订单吗?' : (source == 0 ? '确定驳回该订单？' : ''), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.URL.BASEURL + this.URL.verifyOrderEdit, {
          id: this.examineInfo.id,
          verify_status: source == 1 ? ((this.userInfo.role_id == 13 || this.userInfo.role_id == 15) ? 2 : 4) : ((this.userInfo.role_id == 13 || this.userInfo.role_id == 15) ? 3 : 5),
          verify_note: this.verify_note
        }).then((res) => {
          var res = res.data;
          if (res && res.errno == 0) {
            this.$emit('emit_refresh')
          } else {
            this.loading = false;
            this.$message({
              message: res.err,
              type: 'warning'
            })
          }
        }).catch(() => {
          this.loading = false;
        })
      }).catch(() => {
      });
    },
    orderCancelClick () {
      this.$emit('cancelToast')
    },
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
.container{
}
.basicsBox {
  margin-top: -20px;
  .basics {
    color: #5e5f6b;
    font-size: 14px;
    line-height: 20px;
    vertical-align: middle;
    display: inline-block;
    margin-right: 20px;
    margin-bottom: 4px;
    font-size: 12px;
    width: 30%;
    label {
      vertical-align: middle;
      color: #202652;
    }
    &.change {
      label {
        color: red;
      }
      span {
        color: red;
      }
    }
    em {
      padding-left: 6px;
      vertical-align: middle;
    }
    span {
      vertical-align: middle;
    }
    .input {
      width: 100px;
    }
    .ellipsis {
      width: calc(100% - 120px);
      display: inline-block;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }
}
.writeBox {
  border-top: 1px solid #e6e6ef;
  margin-top: 10px;
  padding-bottom: 0px;
  .title {
    color: #202652;
    font-size: 15px;
    line-height: 21px;
    font-weight: 500;
    margin-top: 10px;
  }
  .writeItem {
    display: inline-block;
    width: 33%;
    vertical-align: middle;
    margin-top: 4px;
    font-size: 12px;
    label {
      color: #202652;
      line-height: 20px;
      display: inline-block;
      vertical-align: middle;
    }
    span {
      line-height: 20px;
    }
    &.change {
      label {
        color: red;
      }
      span {
        color: red;
      }
    }
    em {
      padding-left: 6px;
      vertical-align: middle;
    }
    .input {
      width: calc(100% - 200px);
      display: inline-block;
    }
  }
}
.buttones {
  text-align: center;
  margin-top: 30px;
  button {
    width: 91px;
    height: 32px;
    border-radius: 4px;
    border: 1px solid #dcdfe5;
    color: #202652;
    font-size: 14px;
    background: transparent;
    margin: 0 4px;
  }
  .yes {
    border-color: #5b7bfe;
    background: #5b7bfe;
    color: #ffffff;
  }
}
.stars {
  color: red;
}
.hint {
  font-size: 12px;
  display: inline-block;
  line-height: 17px;
  vertical-align: middle;
  padding-left: 10px;
  color: #ea853c;
}
</style>



// WEBPACK FOOTER //
// src/components/examine/examineToast.vue